import axios from 'axios';

export default {
   
	pre_insercion_rubros(p_email, p_usuario){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_rubros.pre_insercion_rubros",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario
				})
		})
	},

	recuperar_rubros(p_email, p_usuario){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_rubros.recuperar_rubros",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario
				})
		})
	},

	pre_insercion_rubpol(p_email, p_usuario){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_rubros.pre_insercion_rubpol",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario
				})
		})
	},

	recuperar_rubpol(p_email, p_usuario, p_poliza, p_contratante, p_estado){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_rubros.recuperar_rubpol",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_contratante": p_contratante,
				"p_estado": p_estado
				})
		})
	},

 


}
